<p #textoRef class="c-nao-encontrado__texto">
  Não encontramos dados.
</p>